module.exports = __webpack_public_path__ + "media/images/icons/share-cc5c876c9cbfe9035b5f83f6794df989.svg";